import React from 'react'

export default () => (
    <div>
		Store
	</div>
)